/**
 * Authentication Policy API
 * Feature: System Administration Interface (001-admin-settings)
 */
import { fetcher } from '../utils/fetcher';
import type {
  AuthPolicy,
  AuthPolicyUpdate,
  PasswordValidationRequest,
  PasswordValidationResponse,
  NonCompliantUser
} from '../types/auth-policy';

const API_URL = '/api/v1/auth-policy';

export const getAuthPolicy = async (): Promise<AuthPolicy> => {
  return await fetcher(`${API_URL}/read`);
};

export const updateAuthPolicy = async (
  updates: AuthPolicyUpdate
): Promise<AuthPolicy> => {
  return await fetcher(`${API_URL}/update`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
};

export const validatePassword = async (
  request: PasswordValidationRequest
): Promise<PasswordValidationResponse> => {
  return await fetcher(`${API_URL}/validate-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
};

export const getNonCompliantUsers = async (): Promise<NonCompliantUser[]> => {
  return await fetcher(`${API_URL}/non-compliant-users`);
};
